module.exports = __webpack_public_path__ + "static/media/billing-tallying.55d158a1.png";